import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/thealternativeboard.webp';
import screenshot_target from '../../../images/letterfunnel/vincentvermeulen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Vincent Vermeulen"
      firstname="Vincent"
      companyname="The Alternative Board"
      competition="Vistage Netherlands en EO Netherlands"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/vincentvermeulen.js